document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.soon-card-list').forEach(function (slider) {
    const container = slider.closest('.soon-card-list-container');
    if (!container) return;

    const cards = slider.querySelectorAll('.soon-card-container');
    if (cards.length === 0) return;

    const infoBox = container.querySelector('#soon-card-info');
    const infoImage = infoBox?.querySelector('#soon-info-image');
    const infoTitle = infoBox?.querySelector('#soon-info-title');
    const infoDescription = infoBox?.querySelector('#soon-info-description');
    const infoUndertitle = infoBox?.querySelector('#soon-info-undertitle');
    const infoDelivery = infoBox?.querySelector('#soon-info-delivery');
    const infoPrice = infoBox?.querySelector('#soon-info-price');
    const infoDate = infoBox?.querySelector('.soon-date');

    function updateInfo(card) {
      if (!infoBox) return;
      infoTitle.textContent = card.dataset.title || '';
      infoDescription.textContent = card.dataset.description || '';
      infoUndertitle.textContent = card.dataset.undertitle || '';
      infoDelivery.textContent = card.dataset.delivery || '';
      if (infoPrice) {
        const price = card.dataset.price;
        infoPrice.textContent = price ? `${price} €` : '';
      }

      if (infoDate) infoDate.textContent = card.dataset.date || '';

      if (infoImage) {
        infoImage.src = card.dataset.image || '';
        infoImage.alt = card.dataset.imageAlt || infoTitle.textContent;
      }
    }

    // Init
    const activeCard = slider.querySelector('.soon-card--active');
    if (activeCard) updateInfo(activeCard);

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach((c) => c.classList.remove('soon-card--active'));
        card.classList.add('soon-card--active');
        updateInfo(card);
      });
    });

    // 🔁 Appel ici, à l’intérieur de la boucle
    observeActiveSoonCardOnScroll(slider, cards, updateInfo);
  });
});


function observeActiveSoonCardOnScroll(slider, cards, updateInfo) {
  let ticking = false;

  slider.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        let closestCard = null;
        let minDistance = Infinity;
        const sliderRect = slider.getBoundingClientRect();

        cards.forEach((card) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const sliderCenter = sliderRect.left + sliderRect.width / 2;
          const distance = Math.abs(sliderCenter - cardCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closestCard = card;
          }
        });

        if (closestCard && !closestCard.classList.contains('soon-card--active')) {
          cards.forEach((c) => c.classList.remove('soon-card--active'));
          closestCard.classList.add('soon-card--active');
          updateInfo(closestCard);
        }

        ticking = false;
      });

      ticking = true;
    }
  });
}
